(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('insurance-billing-config', {
                parent: 'entity',
                url: '/insurance-billing-config',
                data: {
                    authorities: [],
                    pageTitle: 'InsuranceBillingConfigs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/insurance-billing-config/list/insurance-billing-config.html',
                        controller: 'InsuranceBillingConfigController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_AUDIT_CONFIG];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_AUDIT_CONFIG, access);
                }]
            });
    }
})();
